<template>
	<div
			:class="{
				'page-header-fixed': fixed,
				'is-dirty': isDirty,
				'px-4 px-sm-8': fixed,
				'py-2': fixed,
				'mt-n2 mt-sm-0': fixed
			}"
			:style="{ left: `${fixed ? left : 0}px` }"
			v-resize="getLeftPosition"
	>
		<v-container class="pa-0" :fluid="fluid">
			<v-row :class="{ 'mb-8 mt-sm-n8': !fixed }">
				<v-col cols="12">
					<v-row class="align-start page-title-section py-0 py-md-4" no-gutters>
						<v-col class="mt-1" cols="auto">
							<div
									v-if="shouldShowBackButton || (hasSecondaryMenu && $vuetify.breakpoint.mdAndDown)"
									class="btn-well me-2 me-md-4"
									:class="{ 'btn-well__single': $vuetify.breakpoint.lgAndUp }"
							>

								<v-btn
										v-if="hasSecondaryMenu && $vuetify.breakpoint.mdAndDown"
										v-reveal-btn-label="'Menu'"
										class="me-1"
										color="#e5e5e5"
										depressed
										fab
										:small="$vuetify.breakpoint.smAndDown"
										@click="toggleMenu"
								>
									<v-icon style="transform: rotate(180deg);">mdi-menu-open</v-icon>
								</v-btn>

								<v-btn
										v-if="shouldShowBackButton"
										v-reveal-btn-label="'Back'"
										:color="$vuetify.breakpoint.mdAndDown ? '#e5e5e5' : 'white'"
										depressed
										fab
										:small="$vuetify.breakpoint.smAndDown || $vuetify.breakpoint.lgAndUp"
										@click="navigateBack"
								>
									<v-icon>mdi-chevron-left</v-icon>
								</v-btn>

							</div>
						</v-col>
						<v-col class="py-0" style="margin-top: 2px;">
							<slot name="default">
								<h1
										v-bind="{ ...$attrs, ...localAttrs }"
										class="font-weight-black text-h4 text-sm-h3 text-md-h2"
								>
									{{ title }}
								</h1>
								<div
										v-if="subTitle"
										:class="[
										'font-weight-medium',
										'grey--text',
										'mt-0',
										'text--darken-2',
										'text-subheading-2',
										'text-md-h5'
									]"
								>
									{{ subTitle }}
								</div>
								<div
										v-if="description"
										:class="[
										'grey--text',
										'mt-4',
										'text--darken-2',
										'text-caption'
									]"
								>
									{{ description }}
								</div>
							</slot>
						</v-col>
						<v-col class="pa-0" cols="auto">
							<v-alert
									v-if="isDirty && isEditing"
									:border="$vuetify.breakpoint.smAndUp ? 'left' : null"
									:class="{
										'ms-4 ms-md-8 my-0 rounded-lg': $vuetify.breakpoint.smAndUp,
										'ma-0 position-fixed rounded-t-0': $vuetify.breakpoint.xsOnly,
										'unsaved-edits--fixed': $vuetify.breakpoint.xsOnly
									}"
									:dense="$vuetify.breakpoint.smAndDown"
									:icon="$vuetify.breakpoint.smAndUp ? 'mdi-alert-circle' : false"
									type="warning"
							>
								Unsaved Changes
							</v-alert>
						</v-col>
						<v-col v-if="$slots.actions" class="d-flex ps-4 ps-md-8" cols="auto">
							<slot name="actions"></slot>
						</v-col>
					</v-row>
				</v-col>
				<v-col v-if="!fixed" class="py-0" cols="12">
					<v-divider class="opacity-800"></v-divider>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	inheritAttrs: false,
	name: 'Heading',
	props: {
		backUrl: {
			type: String,
			default: ''
		},
		description: [String, Boolean],
		fixed: Boolean,
		fluid: Boolean,
		isEditing: {
			type: Boolean,
			default: true
		},
		title: {
			type: String,
			default: 'Oops! You Forgot Your Page Title'
		},
		status: {
			type: String,
			default: ''
		},
		statusColor: {
			type: String,
			default: 'white'
		},
		subTitle: [String, Boolean],
	},
	data() {
		return {
			hasSecondaryMenu: false,
			headerHeight: 0,
			left: 0
		};
	},
	computed: {
		...mapGetters('formState', { isDirty: 'getIsDirty' }),
		localAttrs() {
			return {
				class: {
					'has-subheader': this.subTitle,
					'mb-2': this.subTitle
				}
			};
		},
		shouldShowBackButton() {
			return (
					this.backUrl &&
					(
							(this.hasSecondaryMenu && this.$vuetify.breakpoint.mdAndDown) ||
							!this.hasSecondaryMenu
					)
			);
		}

	},
	methods: {
		getLeftPosition() {
			let newLeft = 0;
			const secondaryNavEl = document.getElementById('secondary-nav');
			const sideNavEl = document.getElementById('side-nav');
			const sideNavState = {
				hover:
						this.$vuetify.breakpoint.smOnly ||
						this.$vuetify.breakpoint.mdOnly ||
						(!this.$vuetify.breakpoint.xs && !!secondaryNavEl),
				temporary: this.$vuetify.breakpoint.xs,
				permanent: this.$vuetify.breakpoint.smAndUp
			};
			const secondaryNavState = {
				temporary: this.$vuetify.breakpoint.mdAndDown,
				permanent: this.$vuetify.breakpoint.lgAndUp
			};

			if(!!sideNavEl && sideNavState.permanent && !sideNavState.hover) newLeft += 256;
			if(!!sideNavEl && sideNavState.hover) newLeft += 56;
			if(!!secondaryNavEl && secondaryNavState.permanent) newLeft += 300;

			this.left = newLeft;
		},
		navigateBack() {
			window.location.href = this.backUrl;
		},
		toggleMenu() {
			window.EventBus.$emit('toggle-secondary-nav');
		}
	},
	mounted() {
		this.getLeftPosition();

		const secondaryMenuInterval = setInterval(() => {
			const secondaryMenu = document.getElementById('secondary-nav');
			if(secondaryMenu) {
				this.hasSecondaryMenu = true;
				clearInterval(secondaryMenuInterval);
			}
		}, 20);

		this.$once('customBeforeDestroy', () => clearInterval(secondaryMenuInterval));
	},
	beforeDestroy() {
		this.$emit('customBeforeDestroy');
	}
};
</script>

<style lang="scss" scoped>
.page-title-section {
	min-height: 72px;
}

.page-header-fixed {
	background: white;
	border-bottom: solid 1px #e0e0e0;
	box-shadow: 0 0 16px 16px rgba(255, 255, 255, 0);
	position: fixed;
	right: 0;
	z-index: 1;
	transition: box-shadow 0.3s ease-in-out;

	&.is-dirty {
		border-bottom: none;
		box-shadow: 0 0 16px 16px rgba(255, 127, 0, 0.12);
	}
}

.unsaved-edits--fixed {
	top: 56px;
	left: 50%;
	transform: translateX(-50%);
	padding: 0px 0.5rem;

	font-size: 0.75rem !important;
	font-weight: 700;
	line-height: 1.25rem;
	letter-spacing: 0.0333333333em !important;
}

.btn-well {
	background: #fff;
	border-radius: 23px;
	outline: solid 1px #e5e5e5;
	/*
	box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.15),
	inset 0 4px 5px 0 rgba(0, 0, 0, 0.13),
	inset 0 1px 8px 0 rgba(0, 0, 0, 0.2);
	*/
	padding: 4px;

	&__single {
		outline: solid 1px #757575;
		padding: 3px;
	}
}
</style>
